import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppConfig } from './app.config'
import { AppCountrySettings } from './app-country-settings.config'
import { AppOrganizationSettings } from './app-organization-settings.config'
import { AppSettings } from './app-settings.config'
export const configProviders = [AppConfig, AppSettings, AppCountrySettings, AppOrganizationSettings]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  exports:[]
})
export class ConfigModule { }
